/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleBigQueryGa4RevenueCurrencyData } from './GoogleBigQueryGa4RevenueCurrencyData';
import {
    GoogleBigQueryGa4RevenueCurrencyDataFromJSON,
    GoogleBigQueryGa4RevenueCurrencyDataFromJSONTyped,
    GoogleBigQueryGa4RevenueCurrencyDataToJSON,
    GoogleBigQueryGa4RevenueCurrencyDataToJSONTyped,
} from './GoogleBigQueryGa4RevenueCurrencyData';

/**
 * 
 * @export
 * @interface GoogleBigQueryGa4ReportRowData
 */
export interface GoogleBigQueryGa4ReportRowData {
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    key?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    events?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    sessions?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    purchases?: number;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    revenue?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    purchaseRevenueMissingCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    canonicalPurchaseRevenue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    purchaseRevenueCurrency?: string | null;
    /**
     * 
     * @type {GoogleBigQueryGa4ReportRowDataPurchaseRevenueAvailabilityEnum}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    purchaseRevenueAvailability?: GoogleBigQueryGa4ReportRowDataPurchaseRevenueAvailabilityEnum;
    /**
     * 
     * @type {Array<GoogleBigQueryGa4RevenueCurrencyData>}
     * @memberof GoogleBigQueryGa4ReportRowData
     */
    purchaseRevenueByCurrency?: Array<GoogleBigQueryGa4RevenueCurrencyData>;
}


/**
 * @export
 */
export const GoogleBigQueryGa4ReportRowDataPurchaseRevenueAvailabilityEnum = {
    Available: 'AVAILABLE',
    MixedCurrency: 'MIXED_CURRENCY',
    UnknownCurrency: 'UNKNOWN_CURRENCY',
    Unavailable: 'UNAVAILABLE'
} as const;
export type GoogleBigQueryGa4ReportRowDataPurchaseRevenueAvailabilityEnum = typeof GoogleBigQueryGa4ReportRowDataPurchaseRevenueAvailabilityEnum[keyof typeof GoogleBigQueryGa4ReportRowDataPurchaseRevenueAvailabilityEnum];


/**
 * Check if a given object implements the GoogleBigQueryGa4ReportRowData interface.
 */
export function instanceOfGoogleBigQueryGa4ReportRowData(value: object): value is GoogleBigQueryGa4ReportRowData {
    return true;
}

export function GoogleBigQueryGa4ReportRowDataFromJSON(json: any): GoogleBigQueryGa4ReportRowData {
    return GoogleBigQueryGa4ReportRowDataFromJSONTyped(json, false);
}

export function GoogleBigQueryGa4ReportRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleBigQueryGa4ReportRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
        'events': json['events'] == null ? undefined : json['events'],
        'sessions': json['sessions'] == null ? undefined : json['sessions'],
        'purchases': json['purchases'] == null ? undefined : json['purchases'],
        'revenue': json['revenue'] == null ? undefined : json['revenue'],
        'purchaseRevenueMissingCount': json['purchaseRevenueMissingCount'] === undefined ? undefined : json['purchaseRevenueMissingCount'] === null ? null : json['purchaseRevenueMissingCount'],
        'canonicalPurchaseRevenue': json['canonicalPurchaseRevenue'] === undefined ? undefined : json['canonicalPurchaseRevenue'] === null ? null : json['canonicalPurchaseRevenue'],
        'purchaseRevenueCurrency': json['purchaseRevenueCurrency'] === undefined ? undefined : json['purchaseRevenueCurrency'] === null ? null : json['purchaseRevenueCurrency'],
        'purchaseRevenueAvailability': json['purchaseRevenueAvailability'] == null ? undefined : json['purchaseRevenueAvailability'],
        'purchaseRevenueByCurrency': json['purchaseRevenueByCurrency'] == null ? undefined : ((json['purchaseRevenueByCurrency'] as Array<any>).map(GoogleBigQueryGa4RevenueCurrencyDataFromJSON)),
    };
}

export function GoogleBigQueryGa4ReportRowDataToJSON(json: any): GoogleBigQueryGa4ReportRowData {
    return GoogleBigQueryGa4ReportRowDataToJSONTyped(json, false);
}

export function GoogleBigQueryGa4ReportRowDataToJSONTyped(value?: GoogleBigQueryGa4ReportRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'events': value['events'],
        'sessions': value['sessions'],
        'purchases': value['purchases'],
        'revenue': value['revenue'],
        'purchaseRevenueMissingCount': value['purchaseRevenueMissingCount'],
        'canonicalPurchaseRevenue': value['canonicalPurchaseRevenue'],
        'purchaseRevenueCurrency': value['purchaseRevenueCurrency'],
        'purchaseRevenueAvailability': value['purchaseRevenueAvailability'],
        'purchaseRevenueByCurrency': value['purchaseRevenueByCurrency'] == null ? undefined : ((value['purchaseRevenueByCurrency'] as Array<any>).map(GoogleBigQueryGa4RevenueCurrencyDataToJSON)),
    };
}

